import { NgModule,
     Component,
     Input,
     Inject,
     ChangeDetectionStrategy,
     ChangeDetectorRef,
     ContentChildren,
     ViewChildren,
     ViewChild,
     HostListener,
     Renderer2,
     ElementRef,
     QueryList,
     PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser, isPlatformServer} from '@angular/common';
import { EventList } from '../events';
import { SelectorMethodSignature } from 'rxjs/observable/FromEventObservable';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { timer } from 'rxjs/observable/timer';
import { debounce } from 'rxjs/operators';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { UserLoginService } from 'angular-engine/engine/service/user/user.login.service';
import { ViewEncapsulation } from '@angular/core';
import { NAVIGATION_LINKS, APP_SETTINGS, DEVICE_INFO, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: 'navbar',
    templateUrl: "navbar.template.html",
    styleUrls: [`./navbar.style.scss`],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavBar {
    @Input() live:boolean = false; 
    public siteLinks: any;
    public routes: Array<any>;
    private flattenedRoutes: Array<any> = [];
    private ngUnsubscribe: Subject<any> = new Subject<any>();
    private subscription: Subscription;
    private cdTriggered: boolean = false;
    private activeNode : 'string';
    protected isServer: boolean;
    private oauthSubscription: Subscription;
    public isLoggedIn : boolean;
    public loginName: string = "Login";
    public socialIcons: any;

    private isChrome : boolean = false; 
    private scrolled: boolean = false;
    public logo: string;
    private scrollListener: Observable<any>;

    @ViewChildren('subnav') navpoints:QueryList<ElementRef>;
    @ViewChild('container') container: ElementRef;

    @HostListener('mouseenter') onMouseEnter($event) {
        
    }
    constructor(
        private router: Router,
        private activeRoute: ActivatedRoute,
        private coreEffects: CoreEffects,      
        private changeDetector: ChangeDetectorRef,
        private interactions : EventInteraction,
        private authService: UserLoginService,
        private renderer: Renderer2,
        @Inject(PLATFORM_ID) private platformId: string,
        @Inject(NAVIGATION_LINKS) private navLinks: Array<Object>,
        @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo,
        @Inject(APP_SETTINGS) private settings: Object
    ){
        this.isServer = isPlatformServer(this.platformId);
        //this.subscription = this.interactions.subscribe( e => {
        //    this.revealSubnav(e)
        //});
        if (!this.isServer){
            this.isChrome = this.deviceInfo.userAgent.toLowerCase().indexOf("chrome") > -1;
        }

        if (!this.isServer){
            this.oauthSubscription = this.interactions.subscribe(e => {
                if (e.key == "oauth") {
                    this.checkLoginStatus();
                }
            });
        }

        this.socialIcons = this.settings['SHARING_LINKS'];
    }

    ngOnInit() {

        if (!this.isServer){
            this.checkLoginStatus();
            this.scrollListener = fromEvent(window, 'scroll');

            this.scrollListener.pipe( debounce(() => timer(600)));

            this.scrollListener.takeUntil(this.ngUnsubscribe).subscribe( val => {
                const scrollAmount = window.scrollY;
                const scrollTarget = this.scrolled ? 60 : 100;
                if(scrollAmount > scrollTarget)
                {
                    this.renderer.addClass(this.container.nativeElement, 'scroll');
                    this.scrolled = true;
                }
                else{
                    this.renderer.removeClass(this.container.nativeElement, 'scroll');
                    this.scrolled = false;
                }
            });

            const scrollAmount = window.scrollY;

            if(scrollAmount > 100)
            {
                this.renderer.addClass(this.container.nativeElement, 'scroll');
                this.scrolled = true;
            }
            else{
                this.renderer.removeClass(this.container.nativeElement, 'scroll');
                this.scrolled = false;
            }
        }

        this.logo = this.settings['CLIENT_LOGO'];
        this.siteLinks = this.settings['SHARING_LINKS'];
        if (this.isServer){
            this.routes = this.coreEffects.processCmsRoutes([].concat(this.navLinks), false, null);
            for(let route of this.routes){
                if (route.path === this.router.url){
                    route.selected = true;
                }
            }  
            this.coreEffects.dispatchDataToStore(this.routes, '/navigation');
            if (!this.cdTriggered){
                this.cdTriggered = true;
                this.changeDetector.detectChanges();
            }
        }
        else{
                this.routes = [].concat(this.coreEffects.getCmsRoutesFromStore());
                this.flattenedRoutes = this.flattenResult(this.routes, false, []);
                for(let route of this.routes){
                    if (route.path === this.router.url){
                        route.selected = true;
                    }
                }  
                if (!this.cdTriggered){
                    this.cdTriggered = true;
                    this.changeDetector.detectChanges();
                }  

        }
      

        this.router.events.filter(event => event instanceof NavigationEnd).takeUntil(this.ngUnsubscribe).subscribe((val:NavigationEnd) => {
            const section = this.findSection(val.url);
            if (Array.isArray(this.routes)){
                for (let route of this.routes){
                    if (route['section'] != null){
                        if (route['section'] == section){
                            route.selected = true;
                        }
                        else{
                            route.selected = false;
                        }
                    }
                    else{
                        route.selected = false;
                    }
                }
                this.changeDetector.detectChanges();
            }
        });
        
    }
    
    ngOnDestroy() {
        if (this.subscription){
            this.subscription.unsubscribe();
        }
        if(this.ngUnsubscribe)
        {
            this.ngUnsubscribe.next();
            this.ngUnsubscribe.complete();
            this.ngUnsubscribe.unsubscribe();
        }

        if(this.oauthSubscription)
        {
            this.oauthSubscription.unsubscribe();
        }
    }


    public login() {
        this.authService.toggleLoginState();
        this.isLoggedIn && this.checkLoginStatus();
    }

    public checkLoginStatus(){
        if(!this.isServer)
        {
            this.authService.checkLoginStatus();
            const newLoginName = (this.authService.loginName) ? "Logout " + this.authService.loginName : "Login";
            if (newLoginName != this.loginName){
                this.isLoggedIn = this.authService.isLoggedIn;
                this.loginName = newLoginName;
                this.changeDetector.detectChanges();
            }
            
        }
        else{
            this.isLoggedIn = false;
            this.loginName = "Login";
        }
    }

    //we have a n recursive tree so we need to flatten it to find the section easier
    private flattenResult (inputArray: Array<any>, isChild: boolean, result : Array<any>) {
        isChild = isChild || false;
        var i = 0, len = inputArray.length;
        for (i = 0; i < len; i++) {
            result.push(inputArray[i]);

            if (inputArray[i].children && typeof inputArray[i].children === typeof []) {
                result = this.flattenResult(inputArray[i].children, true, result);
            }
        }
        return result;   
    };

    private findSection(url : string ){
        if (!this.flattenedRoutes) {return "";}
        for (let route of this.flattenedRoutes){
            if (route['path'] != null){
                if (route['path'] == url){
                    return route['section'];
                }
            }
        }
        return "";
    }

    private revealSubnav(e){
        if(e.key == "path"){

           //let arr:Array<ElementRef> = this.navpoints.toArray();
           // for ( let point of arr){
           //     if(point.nativeElement.dataset.parent == e.message){
           //         point.nativeElement.classList.add('active');
           //     }else{
           //         point.nativeElement.classList.remove('active')
           //     }  
           // }
        }
    }

    private isActive(path) : boolean {
        if(this.activeNode == path){
            return true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/navbar/navbar.component.ts